import { RenderContext } from "@certn/cascadia-react/context/RenderContext";
import { GhostButton } from "@certn/cascadia";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";

export const showExpandCollapseAllControl = (
  isForPdfGeneration: boolean,
  options?: Record<string, any>
) => {
  return (options?.showExpandCollapseAllControl ?? true) && !isForPdfGeneration;
};

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  options?: Record<string, any>;
}

export function ExpandCollapseAll(props: Props) {
  const { isOpen, setIsOpen, options } = props;
  const { t } = useTranslation();
  const isPDF = useContext(RenderContext).isForPdfGeneration;

  if (!showExpandCollapseAllControl(isPDF, options)) return <></>;

  return (
    <div className={css({ marginLeft: "auto" })}>
      <GhostButton
        leftIcon={isOpen ? "unfold_less" : "unfold_more"}
        onPress={() => setIsOpen(!isOpen)}
      >
        {isOpen ? t("Collapse all") : t("Expand all")}
      </GhostButton>
    </div>
  );
}
